import React from "react"
import autobind from "class-autobind"
import AppStateStore from "../../../stores/AppStateStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import { IUserFilter, ISelectedFilterTemplateId, EDefaultFilterValues } from "../../../models"
import FilterTemplate from "../FilterTemplate"
import AddUsersFilterTemplateDialogContainer from "./AddUsersFilterTemplateDialogContainer"
import strings from "../../../localization/strings"
import * as api from "../../../api"
import * as utils from "../../../helpers/utils"

interface IProps {
    filterTemplates: IUserFilter[]
    selectedFilterTemplateId: ISelectedFilterTemplateId
    handleChangeFilterTemplates(filterTemplates: IUserFilter[]): void
    handleSelectFilterTemlate(selectedFilterTemplateId: ISelectedFilterTemplateId): void,
    isTimecardFilter?: boolean
}
interface IState {
}

export default class UserFilter extends React.Component<IProps, IState> {
    private AddUsersFilterTemplateDialogContainer
    constructor(props: IProps) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    handleAddFilter(name: string) {
        const filter: IUserFilter = this.AddUsersFilterTemplateDialogContainer.state.filterData
        filter.Id = utils.guid()
        filter.Name = name
        this.props.handleChangeFilterTemplates([...this.props.filterTemplates, filter])
        AppStateStore.setProgressSnackbarContent("loading")
        this.props.isTimecardFilter ?
            api.addTimecardUserFilter(AuthenticationStore.getLoggedInUser().Id, filter).then(() => {
                this.props.handleSelectFilterTemlate(filter.Id)
                AppStateStore.setProgressSnackbarContent(strings.Filter_Saved)
            }) :
            api.addUserFilter(AuthenticationStore.getLoggedInUser().Id, filter).then(() => {
                this.props.handleSelectFilterTemlate(filter.Id)
                AppStateStore.setProgressSnackbarContent(strings.Filter_Saved)
            })
    }

    handleUpdateFilter(name: string) {
        const filter: IUserFilter = this.AddUsersFilterTemplateDialogContainer.state.filterData
        filter.Name = name
        this.props.handleChangeFilterTemplates(this.props.filterTemplates.map(i => i.Id === filter.Id ? filter : i))
        AppStateStore.setProgressSnackbarContent("loading")
        this.props.isTimecardFilter ?
            api.updateTimecardUserFilter(AuthenticationStore.getLoggedInUser().Id, filter).then(() => {
                this.props.handleSelectFilterTemlate(filter.Id)
                AppStateStore.setProgressSnackbarContent(strings.Filter_Updated)
            }) :
            api.updateUserFilter(AuthenticationStore.getLoggedInUser().Id, filter).then(() => {
                this.props.handleSelectFilterTemlate(filter.Id)
                AppStateStore.setProgressSnackbarContent(strings.Filter_Updated)
            })
    }

    handleDeleteFilter(filterId: string) {
        this.props.handleChangeFilterTemplates(this.props.filterTemplates.filter(i => i.Id !== filterId))
        AppStateStore.setProgressSnackbarContent("loading")
        this.props.isTimecardFilter ?
            api.deleteTimecardUserFilter(AuthenticationStore.getLoggedInUser().Id, filterId).then(() => {
                this.props.handleSelectFilterTemlate(EDefaultFilterValues.NONE)
                AppStateStore.setProgressSnackbarContent(strings.Filter_Deleted)
            }) :
            api.deleteUserFilter(AuthenticationStore.getLoggedInUser().Id, filterId).then(() => {
                this.props.handleSelectFilterTemlate(EDefaultFilterValues.NONE)
                AppStateStore.setProgressSnackbarContent(strings.Filter_Deleted)
            })
    }

    render() {
        const editFilterTemplate = (this.props.selectedFilterTemplateId === EDefaultFilterValues.CREATE_NEW || this.props.selectedFilterTemplateId === EDefaultFilterValues.NONE) ?
            null : this.props.filterTemplates.find(i => i.Id === this.props.selectedFilterTemplateId)
        return (
            <FilterTemplate
                addFilterTemplateLabel={strings.Create_New_Employee_Filter}
                editFilterTemplateLabel={strings.Edit_Employee_Filter}
                filterTemplates={this.props.filterTemplates}
                selectedFilterTemplateId={this.props.selectedFilterTemplateId}
                style={{ marginTop: -15, marginLeft: 25 }}
                handleSelectFilterTemlate={this.props.handleSelectFilterTemlate}
                handleSave={name => editFilterTemplate ? this.handleUpdateFilter(name) : this.handleAddFilter(name)}
                handleDeleteFilterTemplate={this.handleDeleteFilter}
            >
                <AddUsersFilterTemplateDialogContainer
                    ref={item => this.AddUsersFilterTemplateDialogContainer = item}
                    editFilterTemplate={editFilterTemplate}
                />
            </FilterTemplate>
        )
    }
}
